import Config from 'config/Config';
import Stores from 'config/Stores';
const defaultImg = `${Config.CDN_BASE}/assets/imgs/default/default2.png`;

// 微信分享给朋友
const shareFriend = ({
  title = '',
  desc = '',
  link = '',
  imgUrl = '',
  suc,
  cancel,
  hideMenu = []
}) => {
  const { cardCode } = Stores.AppMod.userInfo || {};
  if (cardCode) {
    link = `${link}${link.indexOf('?') >= 0 ? '&' : '?'}bindCardCode=${cardCode}`;
  }
  wx.ready(function () {
    wx &&
      wx.hideMenuItems({
        menuList: hideMenu // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
      });
    wx.updateAppMessageShareData({
      title, // 分享标题
      desc, // 分享描述
      link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl || defaultImg, // 分享图标
      success() {
        console.warn('share success');
        // 用户确认分享后执行的回调函数
        suc && suc();
      },
      cancel() {
        console.warn('share error >> ');
        // 用户取消分享后执行的回调函数
        cancel && cancel();
      }
    });
  });
};

// 微信分享到朋友圈
const sharePyq = ({ title = '', link = '', imgUrl = '', suc, cancel }) => {
  const { cardCode } = Stores.AppMod.userInfo || {};
  if (cardCode) {
    link = `${link}${link.indexOf('?') >= 0 ? '&' : '?'}bindCardCode=${cardCode}`;
  }
  wx.ready(function () {
    // 需在用户可能点击分享按钮前就先调用
    wx.updateTimelineShareData({
      title, // 分享标题
      link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl || defaultImg, // 分享图标
      success() {
        // 用户确认分享后执行的回调函数
        suc && suc();
      },
      cancel() {
        // 用户取消分享后执行的回调函数
        cancel && cancel();
      }
    });
  });
};

export { shareFriend, sharePyq };



// WEBPACK FOOTER //
// ./src/utils/wxShare.js